module.exports = __webpack_public_path__ + "static/img/img202.b05bdcd3.jpg";